export * from "./nonpartner-detection.js";
